import { type FC } from 'react';
import {
  type UiHStackProps,
  UiVStack,
  UiStack,
  uiStyles,
  UiText
} from '@/lib/ui';
import BaseDividerHorizontal from '@/base/Divider/Horizontal';

export interface SummaryProps extends UiHStackProps {
}

const Summary: FC<SummaryProps> = () => {
  return (
    <UiVStack
      justifyContent={'flex-start'}
      alignItems={'stretch'}
      // alignItems={'flex-start'}
      // justifyContent={'flex-start'}
      minWidth={'300px'}
      // bgColor={'gray.50'}
      // p={8}
      bgColor={'#fff'}
      // divider={(<BaseDividerHorizontal/>)}
      borderRadius={uiStyles.borderRadius}
      p={8}
    >
      <UiStack flexGrow={1}>
        <UiText variant={'title'}>Registration summary</UiText>
        <UiText>
          During the checkout, the attendee will see the registration summary page. The page will show all the tickets the attendee is buying.
        </UiText>
      </UiStack>
      <BaseDividerHorizontal height={2} />
      <UiText variant={'body1'} color={'text.secondary'}>
        Step required
      </UiText>
    </UiVStack>
  );
};

export default Summary;
